import * as _cq from './cq.module.scss';

export type cqTypes = Partial<_cq.Styles>;
export default _cq as unknown as _cq.Styles;
